package ru.villawonka.app.data.entity.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class TelegramAuthRequest(
    @SerialName("init_data")
    val initData: String,
    @SerialName("device_name")
    val deviceName: String? = null,
    @SerialName("platform_name")
    val osName: String? = null,
    @SerialName("platform_version")
    val osVersion: String? = null,
)

